module.exports = __webpack_public_path__ + "img/inspiring_background_parallax@2x.a964179.jpg";